// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconBase from '@/components/IconBase.vue'
import Datepicker from 'vuejs-datepicker';
import IconForward from '@/components/icons/arrowForward.vue'
import Globals from '@/assets/scripts/global-functions.js'
import Axios from "axios"
import BackButton from '@/components/BackButton.vue'
import NextButton from '@/components/forms/ButtonNext.vue'

export default {
    name: 'EducatorStartDateOfPolicy',
    props: ['value'],
    components: {
        IconArrowBack,
        IconBase,
        IconForward,
        Datepicker,
        BackButton,
        NextButton
    },
    data() {
        return {
            state_disable_1: "",
            state_disable_2: "",
            state_final_1:"",
            state_final_2:"",
            default_state: "",
            commencement_date: "",
            commencement_date_display: "",
            first_month: "",
            second_month: "",
            state_open_date: "",
        }
    },

    

    mounted(){
        this.$parent.CurrentProcess = "EducatorInsuranceProcess";
        
        this.$parent.CheckWindowPathName();
        this.ValidateSessionData();
        var today = new Date(); 
        var future = new Date();
        
        future.setDate(today.getDate()+29);
        this.state_open_date = {
            date: future
        }


        this.first_month = this.getMonthName(today.getMonth());
        this.second_month = this.getMonthName(future.getMonth());
        var afterDate=this.getAfterDate(today);
        
        if(this.state_final_1 == '' && this.state_final_2 == ''){
            this.state_final_1 = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            this.commencement_date_display = today.getDate() + afterDate + ' ' + this.getMonthName(today.getMonth()) + ' ' + today.getFullYear();
            this.commencement_date = today.getFullYear()+'-'+today.getDate()+'-'+today.getMonth();
        }
 
        if(today.getMonth() != future.getMonth()){
            this.state_disable_1 = {
                disabledDates: {
                    to: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
                }
            }   

            this.state_disable_2 = {
                disabledDates: {
                    from: new Date(future.getFullYear(), future.getMonth(), future.getDate()), 
                }
            }
        }else{
            
            //[ "January", "March", "May", "July", "August", "October", "December"];
            //----------------- DATEPICKER 1----------------------------
            var months_with_31 = [ 0, 2, 4, 6, 7, 9, 11];
            var match_months_with_31 = false;
            months_with_31.filter(function (item) {
                if(item == today.getMonth()){
                    match=true;
                }
            });
            
            if(match_months_with_31 && today.getDate() == 1){
                this.state_disable_1 = {
                    disabledDates: {
                        from: new Date(future.getFullYear(), future.getMonth(), future.getDate()),
                    }
                }
            }else{               
                this.state_disable_1 = {
                    disabledDates: {
                        to: new Date(today.getFullYear(), today.getMonth(), today.getDate()), 
                    }
                }
            }
            //--------------  END OF DATEPICKER 1------------------------
            
            
            this.state_disable_2 = {
                disabledDates: {
                    to: new Date(future.getFullYear(), future.getMonth() + 1, future.getDate()), 
                }
            }
            this.second_month= this.getMonthName(future.getMonth() + 1);
        }
    },
    methods: {
        chooseDate : function (params){
            var new_date = '';
            if(params == 1){
                this.state_final_2 = undefined;
                new_date = this.state_final_1;
            }else{
                this.state_final_1 = undefined;
                new_date = this.state_final_2;
            }

            this.commencement_date_display = new_date.getDate() + this.getAfterDate(new_date) + ' ' + this.getMonthName(new_date.getMonth()) + ' ' + new_date.getFullYear();
            this.commencement_date = new_date.getFullYear()+'-'+new_date.getMonth()+'-'+new_date.getDate();
            
           
        },

        getMonthName(index){
            var month = ["January", "February", "March", "April","May", "June", "July", "August", "Septemeber", "October" ,"November", "December"];
            return month[index];
        },
        getAfterDate(today){
            var afterDate = '';
            var day = today.getDate();
            if( day == 1 || day == 21 || day == 31){
                return 'st';
            }else if(day == 2 || day == 22){
                return 'nd';
            }else if(day == 3 || day == 23){
                return 'rd';
            }else{
                return 'th';
            }

        },
        ValidateSessionData() {
            if(this.$parent.EducatorInsuranceProcess.commencement_date != null) {
                this.commencement_date = this.$parent.EducatorInsuranceProcess.commencement_date;

                if(this.$parent.EducatorInsuranceProcess.commencement_date_display == undefined){
                    let commencement_date = new Date(this.commencement_date);
                    var date_display = commencement_date.getDate() + commencement_date + ' ' + this.getMonthName(today.getMonth() + 1) + ' ' + commencement_date.getFullYear();
                    this.commencement_date_display = this.$parent.EducatorInsuranceProcess.commencement_date_display = date_display;
                } else{
                    this.commencement_date_display = this.$parent.EducatorInsuranceProcess.commencement_date_display;
                }
                
                
                var newDate = new Date(this.$parent.EducatorInsuranceProcess.commencement_date);
                var newMonth = parseInt(newDate.getMonth()) + 1;
                var updateMonth = new Date(newDate.getFullYear(), newMonth, newDate.getDate());
                
                this.commencement_date = updateMonth.getFullYear()+'-'+updateMonth.getMonth()+'-'+updateMonth.getDate();
                
                var today = new Date(); 
                if(updateMonth.getMonth() != today.getMonth()){
                    this.state_final_2 = updateMonth;
                }else{
                    this.state_final_1 = updateMonth;
                }
            }
        },
        Next() {
            this.$parent.EducatorInsuranceProcess.commencement_date = this.commencement_date;
            this.$parent.EducatorInsuranceProcess.commencement_date_display = this.commencement_date_display;
            if(this.$parent.EducatorInsuranceProcess.quote_ref_num == undefined){
                //var random_string = this.RandomString(6);  
                //var check_string = this.checkRandomStringInPOS(random_string);
                let generate_string = this.RandomString(6);
                this.$parent.EducatorInsuranceProcess.quote_ref_num = generate_string;
            }else{
                //this.$parent.UpdateCurrentStep(8);
                //this.$parent.SessionUpdate("EducatorInsuranceProcess");
                this.$parent.EducatorNextStep(8,"Premium");
                //this.$router.push({path:'/educator/premium'});
            }
            
        },
        RandomString(length) { 
            var chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
            var result = '';
            for (var i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result.toUpperCase();
        },
        checkRandomStringInPOS(random_string){
            let CheckSessionByReferenceNumber_ = Globals.CheckSessionByReferenceNumber(random_string, this.$parent.Role);
            CheckSessionByReferenceNumber_.then(response => {
                if(response.data.customizations.results.length == 0){
                    let generate_string = this.RandomString(6);
                    this.$parent.EducatorInsuranceProcess.quote_ref_num = generate_string;
                }else{
                    this.$parent.EducatorInsuranceProcess.quote_ref_num = random_string;
                }

                this.$parent.EducatorNextStep(8,"Premium");
                this.$router.push({path:'/educator/premium'});
            })
            .catch(response => { 
                console.error("Check Session By Reference Number", response);
            });
        }

    }
}